import { render, staticRenderFns } from "./SBButtonClosed.html?vue&type=template&id=5cffef1a&scoped=true&"
import script from "./SBButtonClosed.ts?vue&type=script&lang=ts&"
export * from "./SBButtonClosed.ts?vue&type=script&lang=ts&"
import style0 from "./SBButtonClosed.css?vue&type=style&index=0&id=5cffef1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffef1a",
  null
  
)

export default component.exports